import { WORKSPACEID } from "../../actions/workspace/";

export default function(state = [], action) {
  switch (action.type) {
    case WORKSPACEID:
      return action.payload;
    default:
  }

  return state;
}
